import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Rad, RadFilters, RadSort, RadVersions } from '../../lib/types/models/rad/rad'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getRads(
  input: PaginationRequest<RadFilters, RadVersions, RadVersions, RadSort> = {}
) {
  if (!input.sort) input.sort = { title: 'asc' }
  return restApiClient
    .url(encodeNestedObject<PaginationRequest>(constructApiUrl(API.rads.getAll.url, null), input))
    .get<PaginationResponse<Rad>>()
}
